<template>
  <div class="sales-volume-container">
    <!-- pc端展示 -->
    <div class="pc">
      <hm-content title :hidden="hidden">
        <div class>
          <div
            class="flex item-center"
            :class="tabPosition !== 'notStarted' ? 'flex-between' : ''"
          >
            <el-radio-group
              v-model="tabPosition"
              size="small"
              @change="switchTab"
            >
              <!-- <el-radio-button label="all1">全部(123)</el-radio-button> -->
              <!-- <el-radio-button label="all">销量审核</el-radio-button> -->
              <el-radio-button label="waitAudit">待审核</el-radio-button>
              <el-radio-button label="supplier">复核中</el-radio-button>
              <el-radio-button label="notStarted">审核列表</el-radio-button>
              <!-- <el-radio-button label="running">人工审核(2)</el-radio-button>
            <el-radio-button label="end">已审核(3)</el-radio-button>
            <el-radio-button label="reject">已驳回(3)</el-radio-button> -->
            </el-radio-group>
            <div class="flex item-center" v-if="tabPosition !== 'notStarted'">
              <div class="mr10">
                <el-date-picker
                  v-model="queryDate"
                  align="right"
                  size="small"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  :picker-options="pickerOptions"
                  @change="queryDateChange"
                >
                </el-date-picker>
              </div>
              <div
                v-for="(v, i) in sort"
                :key="i"
                @click="sortList(v)"
                class="mr10 pointer"
                :class="{ primary: selectSort.prop === v.prop }"
              >
                {{ v.title }}
                <i class="el-icon-sort" v-if="selectSort.prop !== v.prop"></i>
                <i
                  class="el-icon-sort-down"
                  v-else-if="
                    selectSort.prop === v.prop &&
                      selectSort.order === 'ascending'
                  "
                ></i>
                <i
                  class="el-icon-sort-up"
                  v-else-if="
                    selectSort.prop === v.prop &&
                      selectSort.order === 'descending'
                  "
                ></i>
              </div>
            </div>
          </div>

          <div class="mt20">
            <el-radio-group
              v-model="tabPositionChild"
              size="small"
              @change="switchTabChild"
              v-if="tabPosition === 'notStarted'"
            >
              <el-radio-button label="all"
                >全部</el-radio-button
              >
              <el-radio-button label="systemAgree"
                >待确认</el-radio-button
              >
              <el-radio-button label="personWait"
                >待审核</el-radio-button
              >
              <el-radio-button label="agree"
                >已通过</el-radio-button
              >
              <el-radio-button label="refuse"
                >已驳回</el-radio-button
              >
              <el-radio-button label="hang"
                >挂单</el-radio-button
              >
              <el-radio-button label="refund"
                >退单</el-radio-button
              >
              <el-radio-button label="newGuider"
                >新导购</el-radio-button
              >
              <el-radio-button label="supplierAudit">供应商待审核</el-radio-button>
              <el-radio-button label="monthOrder">待审核月结单</el-radio-button>
              <el-radio-button label="cancel">已取消</el-radio-button>
            </el-radio-group>
          </div>

          <div class="table" v-if="tabPosition === 'notStarted'">
            <div class="table-panel flex flex-end mb20 mt10">
              <el-button v-if="tabPositionChild == 'hang'" type="primary" size="small" @click="batchRejection" style="margin-right: 10px;"
                >批量驳回</el-button
              >
              <!-- <div class="flex item-center input-range">
                <el-input-number v-model="searchCondition.redpackageStartMoney" size="small" :controls="false" placeholder="收益最小值" :min="0"></el-input-number>
                <span class="m-x5">~</span>
                <el-input-number v-model="searchCondition.redpackageEndMoney" size="small" :controls="false" placeholder="收益最大值" :min="0"></el-input-number>
              </div> -->
              <el-select
                size="small"
                clearable
                class="mr10"
                placeholder="请选择商户"
                v-model="searchCondition.storeCode"
                filterable
                remote
                :remote-method="remoteMethod"
              >
                <el-option
                  :label="item.storeName"
                  :value="item.storeCode"
                  v-for="(item) in storeBasicList"
                  :key="item.storeCode"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                style="width: 300px"
                v-model.trim="searchCondition.keyWord"
                :placeholder="keyWordPlaceholder"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-input
                clearable
                v-model.trim="searchCondition.receiptDateStr"
                placeholder="请输入识别时间"
                size="small"
                class="ipt mr10"
                v-if="tabPositionChild !== 'refund'"
              ></el-input>
              <el-input
                clearable
                v-model.trim="searchCondition.receiptSn"
                placeholder="请输入小票号"
                size="small"
                class="ipt mr10"
                v-if="tabPositionChild !== 'refund'"
              ></el-input>
              <el-select
                  size="small"
                  clearable
                  class="mr10"
                  placeholder="请选择审核人"
                  v-if="tabPositionChild != 'hang' && tabPositionChild != 'refund'"
                  v-model="searchCondition.queryPersonAuditUsername"
                  filterable
              >
                <el-option
                    :label="item.itemText"
                    :value="item.itemValue"
                    v-for="(item, i) in queryPersonAuditUsernameList"
                    :key="i"
                >
                </el-option>
              </el-select>

              <el-select
                  size="small"
                  clearable
                  class="mr10"
                  placeholder="请选择审核类型"
                  v-model="searchCondition.priorityType"
                  filterable
              >
                <el-option
                    :label="item.itemText"
                    :value="item.itemValue"
                    v-for="(item, i) in auditType"
                    :key="i"
                >
                </el-option>
              </el-select>

              <!-- <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                class="mr10"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="searchCondition.date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="选择审核开始时间"
                end-placeholder="选择审核结束时间"
              ></el-date-picker> -->
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                class="mr10"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="searchCondition.applyDate"
                type="datetimerange"
                range-separator="至"
                :start-placeholder="startPlaceholder"
                :end-placeholder="endPlaceholder"
              ></el-date-picker>
              <el-select
                v-if="tabPositionChild === 'agree'"
                size="small"
                clearable
                placeholder="请选择审核模式"
                v-model="searchCondition.personAuditUsername"
                class="mr10"
                filterable
              >
                <el-option label="自动审核通过" value="autoAgree"></el-option>
                <el-option label="人工审核通过" value="personAgree"></el-option>
              </el-select>   
              <el-select
                v-if="tabPositionChild === 'hang'"
                size="small"
                style="width: 180px"
                clearable
                placeholder="请选择挂起原因"
                v-model="searchCondition.hangType"
                class="mr10"
                filterable
              >
                <el-option
                  label="身份待认证"
                  value="guider_identity_wait"
                ></el-option>
                <el-option
                  label="供货商余额不足"
                  value="supplier_balance_low"
                ></el-option>
              </el-select>
              
              <el-select
                v-if="tabPositionChild === 'hang'"
                size="small"
                style="width: 180px"
                clearable
                placeholder="请选择供货商"
                v-model="searchCondition.hangSupplierCode"
                class="mr10"
                filterable
              >
                <el-option
                  :label="v.storeName"
                  :value="v.supplierCode"
                  v-for="(v, i) in allHangSupplierList"
                  :key="i"
                ></el-option>
              </el-select>

              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <el-button type="success" size="small" @click="outputDetail"
                >生成报表</el-button
              >
            </div>
            <el-table
              v-if="tabPositionChild !== 'refund'"
              stripe
              border
              ref="brandTable"
              :data="backDeclareCount.declareList.records"
              style="width: 100%"
              id="table"
              size="small"
              :class="tabPositionChild === 'hang'?'':'hideSelect'"
               @selection-change="handleSelectionChange"
               :key="tableKey" 
              >
              <el-table-column
                type="selection"
                :width="tabPositionChild === 'hang'?55:0"
                v-show="tabPositionChild === 'hang'">
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareSn"
                label="申报单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="小票号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="导购姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="电话号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="申报时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptDate"
                label="小票时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptDateStr"
                label="识别时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="计算收益"
              >
                <template slot-scope="scope">
                  <span class="income">￥{{ scope.row.redpackageMoney }}</span>
                </template>
              </el-table-column>

              <el-table-column
                  header-align="center"
                  align="center"
                  label="自动审核流程"
              >
                <template slot-scope="scope">
                  <span
                      class="status success"
                      v-show="scope.row.autoAuditState === 'complate' || !scope.row.autoAuditState"
                  >处理完成</span
                  >
                  <span
                      class="status gray"
                      v-show="scope.row.autoAuditState === 'proc'"
                  >处理中</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                  header-align="center"
                  align="center"
                  label="审核类型"
              >
                <template slot-scope="scope">
                  <span
                      class="status success"
                      v-if="scope.row.declareSn.startsWith('S')"
                  >极速单</span
                  >
                  <span
                      class="status gray"
                      v-else
                  >普通单</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                label="自动审核结果"
              >
                <template slot-scope="scope">
                  <span
                    class="status success"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'agree'"
                    >通过</span
                  >
                  <span
                    class="status gray"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'wait'"
                    >待审核</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'refuse'"
                    >驳回</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="所属商户"
              >
                <template slot-scope="scope">
                  {{ scope.row.storeName }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="hangReason"
                label="挂起原因"
                v-if="tabPositionChild === 'hang'"
              >
                <template slot-scope="scope">
                  {{ scope.row.hangReason }}
                  <!-- <div v-if="scope.row.hangReason === 'guider_identity_wait'">
                    身份待认证
                  </div>
                  <div v-if="scope.row.hangReason === 'supplier_balance_low'">
                    供货商余额不足
                  </div> -->
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="cancelReason"
                label="取消原因"
                v-if="tabPositionChild === 'cancel'"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="personAuditUsername"
                label="审核人"
              >
                <template slot-scope="scope">
                  {{ scope.row.personAuditUsername==null?'':scope.row.personAuditUsername.includes('personAppeal')?'系统驳回':scope.row.personAuditUsername }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="personAuditTime"
                label="人工审核时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.personAuditTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="人工审核结果"
              >
                <template slot-scope="scope">
                  <span
                    class="status success"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'agree'"
                    >通过</span
                  >
                  <span
                    class="status gray"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'wait'"
                    >待审核</span
                  >
                  <span
                    class="status gray"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'cancel'"
                    >已取消</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'refuse'"
                    >驳回</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'hang'"
                    >挂起</span
                  >

                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.personAuditState === 'delete'"
                    >已删除</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                v-if="tabPositionChild === 'refuse'"
                header-align="center"
                align="center"
                prop="refuseReason"
                label="驳回原因"
              >
                <template slot-scope="scope">
                  {{ scope.row.refuseReason }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="viewDetails(scope.row)"
                      >申报详情</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table
              v-if="tabPositionChild === 'refund'"
              stripe
              border
              ref="brandTable"
              :data="refundList"
              style="width: 100%"
              id="table"
              size="small"
              :key="tableKey" 
              :class="tabPositionChild === 'hang'?'':'hideSelect'"
            >
            <el-table-column
                type="selection"
                :width="tabPositionChild === 'hang'?55:0"
                v-show="tabPositionChild === 'hang'">
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refundSn"
                label="退款单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareSn"
                label="申报单号"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="小票号"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="导购姓名"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="电话号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="退款时间"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="receiptDate"
                label="小票时间"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                label="退款金额"
              >
                <template slot-scope="scope">
                  <span class="income">￥{{ scope.row.redpackageMoney }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                label="自动审核结果"
              >
                <template slot-scope="scope">
                  <span
                    class="status success"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'agree'"
                    >通过</span
                  >
                  <span
                    class="status gray"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'wait'"
                    >待审核</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.systemAuditState === 'refuse'"
                    >驳回</span
                  >
                </template>
              </el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="所属商户"
              >
                <template slot-scope="scope">
                  {{ scope.row.storeName }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="hangReason"
                label="挂起原因"
                v-if="tabPositionChild === 'hang'"
              >
                <template slot-scope="scope">
                  {{ scope.row.hangReason }}
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="viewDetails(scope.row)"
                      >退单详情</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination" v-if="tabPositionChild !== 'refund'">
              <el-pagination
                background
                :total="backDeclareCount.declareList.total"
                @current-change="pagingDeclare"
                @size-change="handleSizeChangeDeclare"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
                :page-size="pageSize"
              ></el-pagination>
            </div>
            <div class="hm-pagination" v-else>
              <el-pagination
                background
                :total="refundtotal"
                @current-change="pagingDeclare"
                @size-change="handleSizeChangeDeclare"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
                :page-size="pageSize"
              ></el-pagination>
            </div>
          </div>

          <div class="table mt10" v-if="tabPosition !== 'notStarted'">
            <div class="mb20">
              <el-radio-group
                v-model="orderType"
                @change="switchOrderType"
              >
                <el-radio label="normal">
                  普通单
                </el-radio>
                <el-radio label="month">
                  月结单
                </el-radio>
              </el-radio-group>
            </div>
            <el-row :gutter="12">
              <el-col
                :xs="12"
                :sm="12"
                :md="6"
                :lg="6"
                :xl="6"
                class="mb20"
                v-for="(v, i) in provinceList"
                :key="i"
              >
                <el-card
                  @click.native="details(v)"
                  shadow="hover"
                  class="card pointer"
                  :body-style="{ padding: '0px' }"
                  :style="v.backgroundImage"
                >
                  <div
                    slot="header"
                    class="companyTitle flex item-center flex-between"
                  >
                    <div>
                      {{ v.provinceName }}
                    </div>
                    <div style="font-size:14px">
                      <div class="text-right">
                        最早申报时间:
                      </div>
                      <div>
                        {{ v.minDeclareTime }}
                      </div>
                    </div>
                  </div>
                  <div class="shengheType">
                    <p class="tit">销量申报待审核</p>
                    <p>
                      <span class="titval"> {{ v.storeNum }}</span>
                      <span>商户</span>
                      <span class="titval"> {{ v.watiNum }}</span>
                      <span>单</span>
                    </p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <!-- <div class="hm-pagination" v-if="queryProvinceList">
              <el-pagination
                background
                :total="provinceTotal"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>

            <div v-else>暂无数据.......</div> -->
          </div>
        </div>
        <!-- <el-dialog
          title="驳回备注"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-form label-width="80px">
            <el-form-item label="驳回原因">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="reason"
              ></el-input>
            </el-form-item>
            <div class="reject-reason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="submitRuleForm" size="small" type="primary"
              >保存</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog> -->
        <el-dialog
          title="申报详情"
          :visible="detailsVisible"
          @close="detailsVisible = false"
          width="90%"
          custom-class="sales-volumn-dialog"
        >
          <div
            class="p20 flex-between"
            :class="{
              flex: personAuditState === 'wait' || personAuditState === 'hang'
            }"
          >
            <div
              class="mr10"
              :class="{
                wb80: personAuditState === 'wait' || personAuditState === 'hang'
              }"
            >
              <div class="flex flex-center mb20">
                <div class="flex-1">
                  导购姓名：<span class="blue">{{
                    detailsDeclare.guiderName
                  }}</span>
                </div>
                <div class="flex-1">电话：{{ detailsDeclare.guiderPhone }}</div>
                <div class="flex-1">
                  所属门店商：
                  {{ detailsDeclare.guiderName }}
                </div>
                <div class="flex-1">
                  所属门店：
                  <span class="blue"> {{ detailsDeclare.shopName }}</span>
                </div>
                <!-- <div class="flex-1">
                  申报单号：{{ detailsDeclare.declareSn }}
                </div> -->
              </div>
              <div class="flex flex-center mb20">
                <div class="flex-1">
                  小票号：<el-input
                    v-model="detailsDeclare.receiptSn"
                    clearable
                    style="width: 80%"
                    placeholder="请填写小票号"
                    size="small"
                    class="ipt"
                  ></el-input>
                </div>
                <!-- <div class="flex-1">
                  申报日期：
                  {{ detailsDeclare.declareTime }}
                </div> -->
                <div class="flex-1">
                  小票日期：
                  {{ detailsDeclare.receiptDate }}
                </div>
              </div>

              <div class="img-list mb20">
                <el-image
                  v-for="(v, i) in detailsDeclare.srcList"
                  :key="i"
                  style="width: 100px; height: 100px"
                  class="mr10"
                  :src="v"
                  :preview-src-list="detailsDeclare.srcList"
                ></el-image>
              </div>
              <el-table
                class="mb20"
                border
                :data="detailsDeclare.billDetailsBoList"
                stripe
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column
                  prop="brandName"
                  label="商品品牌"
                  header-align="center"
                  align="center"
                ></el-table-column>

                <el-table-column
                  prop="goodsName"
                  label="商品名称"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="ocrGoodsName"
                  label="匹配OCR商品名称"
                  header-align="center"
                  align="center"
                  width="200"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-input
                        v-model="scope.row.ocrGoodsName"
                        clearable
                        style="width: 180px"
                        placeholder="请填写匹配OCR商品名称"
                        size="small"
                        class="ipt"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goodsNum"
                  label="销售商品数量"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="提成基数"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.redpackageMoney / scope.row.goodsNum }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="redpackageMoney"
                  label="计算提成"
                  header-align="center"
                  align="center"
                  ><template slot-scope="scope">
                    <div class="primary">¥{{ scope.row.redpackageMoney }}</div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="flex flex-end">
                <span style="fontsize: 18px; fontweight: 600"> 总计提成：</span>
                <span style="fontsize: 18px; fontweight: 600" class="primary">
                  ¥{{ detailsDeclare.total }}</span
                >
              </div>
              <div
                class="btn-wrapper flex flex-center"
                v-if="
                  personAuditState === 'wait' || personAuditState === 'hang'
                "
              >
                <el-button
                  @click="agree"
                  size="small"
                  type="success"
                  style="width: 200px; height: 100px; font-size: 35px"
                  >同意申报</el-button
                >
                <el-button
                  @click="jujue"
                  size="small"
                  type="danger"
                  style="width: 200px; height: 100px; font-size: 35px"
                  >驳回申报</el-button
                >
              </div>
            </div>
            <div
              class="ml10"
              :class="{
                wb20: personAuditState === 'wait' || personAuditState === 'hang'
              }"
              v-if="personAuditState === 'wait' || personAuditState === 'hang'"
            >
              <div class="title">OCR识别结果</div>
              <div class="ocr scrollocr">
                <div
                  v-for="(v, i) in detailsSalesVolume.ocrResultList"
                  :key="i"
                  class="mb10"
                >
                  {{ v }}
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
      </hm-content>
    </div>
    <el-dialog
      title="驳回备注"
      :visible="refuseVisible"
      @close="refuseVisible = false , isBatch = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="refuseReason">
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因，可直接选择下方模板"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="ruleForm.refuseReason"
          ></el-input>
        </el-form-item>
        <div class="reject-refuseReason">
          <el-radio-group v-model="rejectReason" @change="switchRejectReason">
            <div v-for="(v, i) in rejectTemp" :key="i">
              <el-radio :label="i">{{ v }}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
          >确认</el-button
        >
        <el-button @click="refuseVisible = false , isBatch = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退单详情"
      :visible="refundVisible"
      @close="refundVisible = false"
      custom-class="sales-volumn-dialog"
      width="1400px"
      :close-on-click-modal="false"
    >
      <div class="flex">
        <div
          class="table"
          :class="detailsSalesVolumeRefund.receiptImg ? 'flex-1' : ''"
        >
          <div class="flex flex-between mb10">
            <div>所属商户:{{ row.storeName }}</div>
            <div>所属门店:{{ detailsSalesVolumeRefund.shopName }}</div>
            <div>退款时间:{{ row.declareTime }}</div>
          </div>
          <div class="flex flex-between mb10">
            <div>退款单号:{{ row.refundSn }}</div>
            <div>导购姓名:{{ row.guiderName }}</div>
            <div>导购电话:{{ row.guiderPhone }}</div>
          </div>
          <el-table
            class="mb20"
            border
            :data="detailsRefund"
            stripe
            style="width: 100%"
            height="500px"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="goodsName"
              label="商品名称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goodsPic"
              label="商品图片"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.goodsPic"
                  :preview-src-list="[scope.row.goodsPic]"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsNum"
              label="商品数量"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="refundAmount"
              label="退款金额"
              header-align="center"
              align="center"
            ></el-table-column>
          </el-table>
          <div class="flex flex-end" style="fontSize:18px;fontWeight:600;">
            合计金额：{{ detailsSalesVolumeRefund.totalRefundAmount }}
          </div>
        </div>
        <div class="flex-1" v-if="detailsSalesVolumeRefund.receiptImg">
          <el-image
            lazy
            style="width:100%;borderRadius:6px;"
            class="ml10"
            :src="detailsSalesVolumeRefund.receiptImg"
            :preview-src-list="[detailsSalesVolumeRefund.receiptImg]"
          ></el-image>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer flex flex-center">

        <el-button @click="refundVisible = false" size="small">关闭</el-button>
      </span> -->
    </el-dialog>
    <!-- 移动端展示 -->
    <!-- <div class="mobile">
      <div class="tabs flex flex-between">
        <div
          @click="switchTab(i)"
          class="tab"
          :class="{ active: activeTab === i }"
          v-for="(v, i) in salesVolumeList.records"
          :key="i"
        >
          {{ v.storeName }}
        </div>
      </div>
      <div class="scroll-content">
        <div class="control-panel flex">
          <div class="ipt-wrapper flex-1 flex item-center">
            <span class="icon hmicon icon-search"></span>
            <form @submit="search">
              <input
                type="search"
                ref="ipt"
                class="flex-1"
                placeholder="请输入导购名称/电话/单号"
                v-model="keywords"
              />
            </form>
          </div>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="申报开始时间"
            end-placeholder="申报结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </div>
        <ul class="list">
          <li
            v-infinite-scroll="load"
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in mobileList"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="tag">申报单号</div>
                <div class="user-info flex-1">{{ v.orderNo }}</div>
              </div>
              <div>
                计算收益：
                <span class="price">￥{{ v.price }}</span>
              </div>
            </div>
            <div class="info">
              <div>
                <span class="date gray">导购姓名：{{ v.guideName }}</span>
              </div>
              <div>
                <span class="date gray">申报日期：{{ v.date }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
import { createRgba2 } from "@/store/modules/guiderCommission/auditList";
import moment from "moment";
export default {
  computed: {
  ...mapGetters(["detailsSalesVolume"]),
  },
  data() {
    return {
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now() + 8.64e7;
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const start = new Date(
                moment().format("YYYY/MM/DD") + " 00:00:00"
              );
              const end = new Date(moment().format("YYYY/MM/DD") + " 23:59:59");
              // const end = new Date();
              // end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date(
                moment()
                  .subtract(1, "days")
                  .format("YYYY/MM/DD") + " 00:00:00"
              );
              const end = new Date(
                moment()
                  .subtract(1, "days")
                  .format("YYYY/MM/DD") + " 23:59:59"
              );
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近7天",
            onClick(picker) {
              const start = new Date(
                moment()
                  .subtract(7, "days")
                  .format("YYYY/MM/DD") + " 00:00:00"
              );
              const end = new Date(moment().format("YYYY/MM/DD") + " 23:59:59");
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      queryDate: "",
      selectSort: {
        title: "",
        order: "",
        prop: ":"
      },
      sort: [
        {
          title: "按时间排序",
          order: "",
          prop: "minDeclareTime"
        },
        {
          title: "按单量排序",
          order: "",
          prop: "watiNum"
        }
      ],
      dateSort: "",
      numSort: "",
      detailsRefund: [],
      refundVisible: false,
      hidden: true,
      ruleForm: {
        refuseReason: ""
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change"
        }
      },
      refuseVisible: false,
      personAuditState: "",
      loading: false,
      noMore: false,
      auditState: "agreen",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg"
      ],
      detailsVisible: false,
      rejectReason: "",
      reason: "",
      dialogVisible: false,
      isOutputing: false,
      auditType:[],
      list: [
        {
          orderSn: "6125615514",
          income: 548,
          status: "audit_pass"
        }
      ],
      searchCondition: {
        applyDate: "",
        queryPersonAuditUsername: "",
        priorityType: "",
        // redpackageStartMoney: undefined,
        // redpackageEndMoney: undefined
      },
      total: 0,
      currentPage: 1,
      pageSize: 10,
      textCode: "",
      rejectTemp: [],
      tabPosition: "waitAudit",
      tabPositionChild: "all",
      activeTab: 0,
      // 移动端data
      keywords: "",
      tabList: [
        {
          name: "自动审核"
        },
        {
          name: "人工审核"
        },
        {
          name: "已审核"
        },
        {
          name: "已驳回"
        }
      ],
      mobileList: [],
      storeBasicList: [],
      allStoreBasicList: [],
      refundList: [],
      refundtotal: 0,
      detailsSalesVolumeRefund: {},
      row: {},
      allHangSupplierList: [],
      provinceList: [],
      provinceTotal: 0,
      declareVersion: "",
      queryPersonAuditUsernameList: [],
      keyWordPlaceholder: "请输入申请单号/导购姓名/电话号码",
      startPlaceholder: "选择申报开始时间",
      endPlaceholder: "选择申报结束时间",
      orderType: "normal",
      firstIn: true,
      selectDeclarations:[],
      isBatch:false,
      tableKey:''
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    ...mapGetters([
      "salesVolumeList",
      "declareList",
      "detailsDeclare",
      "backDeclareCount",
      "detailsSalesVolume",
      "queryProvinceList"
    ])
  },
  watch: {},
  created() {
    console.log("declareVersion", this.$route.query.declareVersion)
    if (this.$route.query.declareVersion) {
      this.declareVersion = this.$route.query.declareVersion;
    }
    if (sessionStorage.getItem("Author")) {
      const { tabPosition, tabPositionChild } = JSON.parse(
        sessionStorage.getItem("Author")
      );
      this.tabPosition = tabPosition;
      this.tabPositionChild = tabPositionChild;
    }
    const startTime = moment()
      .subtract(1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [startTime, endTime];
    this.getParamsCookie();
    this.queryList();
    console.log('当前选项卡-->',this.tabPosition)
    if (this.tabPosition === "notStarted") {
      this.queryStoreBasicList();
      this.queryDeclareList();
    }
    this.queryAuditUsernameList();
    let queryTime = JSON.parse(localStorage.getItem("queryTime"));
    this.queryDate = queryTime.queryStartTime
      ? [queryTime.queryStartTime, queryTime.queryEndTime]
      : "";


    this.getAuditType();
  },
  activated() {
    const canRefresh = sessionStorage.getItem("pageRefresh");
    if (canRefresh) {
      console.log('刷新');
      // this.search();
      sessionStorage.removeItem("pageRefresh");
    }
    if(this.$route.query.keyWord){      
      this.searchCondition.keyWord = this.$route.query.keyWord;
    }
    if(this.$route.query.queryDay){
      let startTime = moment()
      .subtract(this.$route.query.queryDay, "days")
      .format("YYYY-MM-DD HH:mm:ss");
      let endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      this.searchCondition.applyDate = [startTime, endTime];
    }
    if(this.$route.query.tabPositionChild){
      this.tabPosition = "notStarted";
      this.tabPositionChild = this.$route.query.tabPositionChild;
      this.queryDeclareList();
    }
  },
  beforeRouteLeave(to, form, next) {
    console.log('离开此页面')
    next();
    if (to.name !== "DetailsSalesVolume") {
      sessionStorage.removeItem("Author");
    }
  },
  methods: {
    // 获取审核类型
    async getAuditType() {
      const { result } = await this.$store.dispatch("inquireAboutBenefits");
      if(result){
        this.auditType = result;
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.storeBasicList = this.allStoreBasicList.filter(v => v.storeName.indexOf(query) > -1);
      } else {
        this.storeBasicList = [];
      }
    },
    async queryAuditUsernameList() {
      const { result } = await this.$store.dispatch("queryDictItemsCode", {dictCode: "redpackage_audit_username"});
      this.queryPersonAuditUsernameList = result;
      console.log("result", result);
    },
    queryDateChange(val) {
      console.log("val: ", val);
      this.currentPage = 1;
      this.queryList();
    },
    sortList(selectSort) {
      switch (selectSort.order) {
        case "ascending":
          selectSort.order = "descending";
          break;
        case "descending":
          selectSort.order = "ascending";
          break;
        default:
          selectSort.order = "ascending";
      }
      this.selectSort = selectSort;
      this.queryList();
    },
    async queryHangSupplierList() {
      const { result } = await this.$store.dispatch("queryHangSupplierList");
      this.allHangSupplierList = result;
    },
    async queryStoreBasicList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allStoreBasicList = result || [];
    },
    search() {
      this.currentPage = 1;
      this.queryDeclareList();
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },
    outputDetail() {
      let params = {
        auditState: this.tabPositionChild === "all" ? "" : this.tabPositionChild
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.declareStartTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.declareEndTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      searchCondition.auditStartTime =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.auditEndTime =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[1]
          : "";
      Object.assign(params, searchCondition);
      this.$store.dispatch("exoprtDeclareList", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
      }, 0);
    },
    // search(e) {
    //   e.preventDefault();
    //   this.$refs.ipt.blur();
    //   this.queryList();
    // },
    setParamsCookie() {
      setCookie({
        key: "salesVolumeParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          tabPositionChild: this.tabPositionChild
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "salesVolumeParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryDeclareList() {
      console.log(1111111111)
      if (
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
      ) {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          auditType: this.auditType,
          auditState:
            this.tabPositionChild === "all" ? "" : this.tabPositionChild
        };

        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        if (this.tabPositionChild !== "hang") {
          searchCondition.hangType = "";
          searchCondition.hangSupplierCode = "";
        }
        searchCondition.declareStartTime =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.declareEndTime =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        searchCondition.auditStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.auditEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";
        this.setParamsCookie();
        Object.assign(params, searchCondition);
        
        if (this.tabPositionChild !== "refund") {
          return this.$store.dispatch("backDeclareCount", params);
        } else {
          this.$store.dispatch("backDeclareCount", params).then(res => {
            this.refundList = res.result.declareList.records;
            this.refundtotal = res.result.declareList.total;
          });
        }
      } else {
        this.$message({
          message: "请选择申报时间!",
          type: "warning"
        });
      }
    },
    createRandom(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    createRgba() {
      const r = Math.floor(this.createRandom(0, 200));
      const g = Math.floor(this.createRandom(0, 200));
      const b = Math.floor(this.createRandom(0, 200));
      const a = 0.3;
      const aLight = 0.5;
      return `backgroundImage: linear-gradient(-90deg, rgba(${r}, ${g}, ${b}, ${a}), rgba(${r}, ${g}, ${b}, ${aLight}))`;
    },
    async queryList() {
      this.loading = false;
      this.noMore = true;

      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        declareVersion: this.declareVersion,
        queryType: this.tabPosition,
        orderType: this.orderType,
      };
      params.queryStartTime =
        this.queryDate && this.queryDate.length > 0 ? this.queryDate[0] : "";
      params.queryEndTime =
        this.queryDate && this.queryDate.length > 0 ? this.queryDate[1] : "";
      Object.assign(params, this.selectSort);
      const { result } = await this.$store.dispatch(
        "queryProvinceList",
        params
      );
      result.forEach((v,i) => {
        v.backgroundImage = createRgba2(i);
      });

      this.provinceList = result;

      // return this.$store.dispatch("querySalesVolumeList", params);
    },

    switchTab(val) {
      this.tableKey = new Date().getTime()
      if (val === "notStarted") {
        this.currentPage = 1;
        this.pageSize = 10;
        if(this.firstIn){
          this.queryStoreBasicList();
          this.firstIn = false;
        }
        this.queryDeclareList();
      } else {
        this.currentPage = 1;
        this.pageSize = 15;
        this.queryList();
      }

      this.backDeclareCount.declareList.records = [];
      this.backDeclareCount.declareList.total = 0;
    },
    switchOrderType(){
      this.currentPage = 1;
      this.pageSize = 15;
      this.queryList();
    },
    switchTabChild(val) {
      if(val === 'refund'){
        this.keyWordPlaceholder = "请输入退款单号/申报单号/导购姓名/电话号码";
        this.startPlaceholder = "选择退款开始时间";
        this.endPlaceholder = "选择退款结束时间";
      }else{
        this.keyWordPlaceholder = "请输入申请单号/导购姓名/电话号码";
        this.startPlaceholder = "选择申报开始时间";
        this.endPlaceholder = "选择申报结束时间";
      }
      if (val !== "agree") {
        this.searchCondition.personAuditUsername = "";
      }
      if (val === "hang") {
        this.queryHangSupplierList();
      }
      this.$refs.brandTable.doLayout();
      this.backDeclareCount.declareList.records = [];
      this.refundList = [];

      this.currentPage = 1;
      this.pageSize = 10;
      this.queryDeclareList();

      if (val === "zidong") {
        this.textCode = "sale_audit_ai_template";
      } else if (val === "rengong") {
        this.textCode = "sale_audit_manual_template";
      }
      this.queryDict();
    },
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: this.textCode
      });
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    details(v) {
      // localStorage.setItem("sh", v.storeName);
      // this.$router.push({
      //   name: "SalesToReview",
      //   query: {
      //     storeCode: v.storeCode
      //   }
      // });
      localStorage.setItem("provinceName", v.provinceName);
      localStorage.setItem(
        "queryTime",
        JSON.stringify({
          queryStartTime:
            this.queryDate && this.queryDate.length > 0
              ? this.queryDate[0]
              : "",
          queryEndTime:
            this.queryDate && this.queryDate.length > 0 ? this.queryDate[1] : ""
        })
      );
      this.$router.push({
        name: "SalesToReview",
        query: {
          storeProvince: v.storeProvince,
          declareVersion: this.declareVersion,
          queryType: this.tabPosition,
          orderType: this.orderType,
        }
      });
    },
    async submitReject(formName) {
      if(this.isBatch){
        for (const v of this.selectDeclarations) { 
          await this.detail(v)
          this.$refs[formName].validate(valid => {
            if (valid) {
                this.ruleForm.personAuditState = "refuse";
                Object.assign(this.detailsSalesVolume, this.ruleForm);
                if (
                    this.detailsSalesVolume.receiptDate !== "" &&
                    this.detailsSalesVolume.receiptDate !== null
                ) {
                  this.detailsSalesVolume.receiptDate = `${this.detailsSalesVolume.receiptDate.substring(
                      0,
                      10
                  )} 00:00:00`;
                }

                if (this.hasRelDeclareSn) {
                  this.detailsSalesVolume.relRejectDeclareSn = this.relDeclareSn;
                }

                if (this.detailsSalesVolume.receiptSn && this.detailsSalesVolume.receiptSn.length > 32){
                  this.$message({
                    message: "小票号长度不能超过32位!",
                    type: "warning"
                  });
                  return;
                }

                console.log("detailsSalesVolume", this.detailsSalesVolume);

                this.$store
                    .dispatch("rejectSalesVolumeList", this.detailsSalesVolume)
                    .then(res => {
                      if (res.code === "0") {
                        this.refuseVisible = false;

                          this.$message({
                            message: "操作成功!",
                            type: "success"
                          });
                          // setTimeout(() => {
                          //   this.resetRuleForm();
                          // }, 0);
                          // this.detail();
                          this.queryDeclareList();
                        }
                    });
              } else {
                return false;
              }
          });
        }
      }else{
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.ruleForm.personAuditState = "refuse";
            Object.assign(this.detailsSalesVolume, this.ruleForm);
            this.$store
              .dispatch("rejectSalesVolumeList", this.detailsSalesVolume)
              .then(res => {
                if (res.code === "0") {
                  this.refuseVisible = false;
                  this.$message({
                    message: "操作成功!",
                    type: "success"
                  });
                  // setTimeout(() => {
                  //   this.resetRuleForm();
                  // }, 0);

                  this.queryDeclareList();
                }
              });
          } else {
            return false;
          }
        });
      }
    },
    resetRuleForm() {
      this.ruleForm.personAuditState = "";
      this.rejectReason = "";
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    async detailChargebacks(row) {
      let declareSn = "";
      if(this.tabPositionChild === "refund"){
        declareSn = row.refundSn
      }else{
        declareSn = row.declareSn
      }
      const { result } = await this.$store.dispatch(
        "detailsRefundSalesVolume",
        {
          declareSn,
          auditState: "refund",
          declareVersion: row.declareVersion
        }
      );
      this.detailsSalesVolumeRefund = result;
      this.detailsRefund = result.refundBillDetailsModelList;
    },
    viewDetails(row) {
      this.row = row;
      console.log(8888888)
      console.log(row)
      if (this.tabPositionChild === "refund") {
        this.detailChargebacks(row);
        this.refundVisible = true;
      } else {
        this.personAuditState = row.personAuditState;
        // let routeData = this.$router.resolve({
        //     path: "/guiderCommission/auditList/detailsSalesVolume",
        //     query: {
        //       declareSn: row.declareSn
        //     }
        //   });

        //   window.open(routeData.href, '_blank');
        // this.$router.push({
        //   name: "DetailsSalesVolume",
        //   query: {
        //     declareSn: row.declareSn
        //   }
        // });
        this.$router.push({
          name: "DetailsSalesVolumeNew",
          query: {
            declareSn: row.declareSn,
            declareVersion: row.declareVersion,
            // is_audit_details: 1,
            receiptId: row.receiptId
          }
        });


        let Author = {
          tabPosition: this.tabPosition,
          tabPositionChild: this.tabPositionChild
        };
        sessionStorage.setItem("Author", JSON.stringify(Author));
      }

      // if(row.personAuditState === 'wait' || row.personAuditState === 'hang'){
      //   let routeData = this.$router.resolve({
      //     path: "/guiderCommission/auditList/detailsSalesVolume",
      //     query: {
      //       declareSn: row.declareSn
      //     }
      //   });

      //   window.open(routeData.href, '_blank');
      // }else{
      //   this.personAuditState = row.personAuditState;
      //   this.detailsVisible = true;
      //   this.$store.dispatch("detailsDeclare", { declareSn: row.declareSn })
      //   this.$store.dispatch("detailsSalesVolumeList", {
      //     declareSn: row.declareSn
      //   });
      // }
    },
    agree() {
      if (this.detailsDeclare.receiptSn === "") {
        this.$message({
          message: "请小票号!",
          type: "warning"
        });
      } else {
        let flag = false;
        this.detailsDeclare.billDetailsBoList.map(v => {
          if (v.ocrGoodsName === "") {
            flag = false;
          }
        });
        if (flag) {
          this.$message({
            message: "请填写OCR识别名称!",
            type: "warning"
          });
        } else {
          const params = JSON.parse(JSON.stringify(this.detailsDeclare));
          params.personAuditState = "agree";
          this.$store.dispatch("rejectSalesVolumeList", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功!",
                type: "success"
              });
              this.detailsVisible = false;
              this.queryDeclareList();
            }
          });
        }
      }
    },

    jujue() {
      this.refuseVisible = true;
    },
    submitRuleForm() {},
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingDeclare(page) {
      this.currentPage = page;
      this.queryDeclareList();
    },
    handleSizeChangeDeclare(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryDeclareList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    // 移动端事件
    load() {
      this.loading = true;
      // this.currentPage++;
    },
    // toDetails(v) {
    //   this.$router.push({
    //     name: "SalesVolumeDetails"
    //   });
    // }

    // 批量驳回
    async queryAuditTemplate() {
      const { result } = await this.$store.dispatch("queryAuditTemplate");
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    batchRejection(){
      if(this.selectDeclarations.length<1){
          this.$message({
            message: "至少选择一个申报单",
            type: "warning"
          });
          return false
      }
      this.isBatch = true
      this.queryAuditTemplate()
      this.resetRuleForm()
      this.refuseVisible = true
    },
    handleSelectionChange(val) {
      this.selectDeclarations = val
    },
    // 获取申报单详情  获取退单详情
    async detail(v) {
      console.log('获取退单详情');
      this.hasRelDeclareSn = false;
      this.relDeclareSn = "";
      let params = {
        // declareSn:v.declareSn,
        declareSn: v.declareSn || v.refundSn,
        queryStartTime: this.queryDate[0]?this.queryDate[0]:'',
        queryEndTime: this.queryDate[1]?this.queryDate[1]:'',
        declareVersion: v.declareVersion
      };
      if (v.declareSn) {
        return this.$store
            .dispatch("detailsSalesVolumeList", params)
            .then(res => {
              console.log("detail if res:::", res)
              this.declareRow = res.result.records;
              this.receiptId = res.result.receiptId;
              if (res.result.receiptDateStr !== "" && res.result.receiptDateStr) {
                this.receiptDateStrLength = res.result.receiptDateStr.length;
              }
              if (res.result.ocrShopName) {
                this.copyOcrShopName = JSON.parse(
                    JSON.stringify(res.result.ocrShopName || "")
                );
              }

              // this.queryTempConfig(res.result.shopId);
              // this.queryNewNumAutoEnableSwitch(res.result.storeCode, res.result.shopId);
              this.numAutoEnableSwitchStoreCode = res.result.storeCode;
              this.numAutoEnableSwitchShopId = res.result.shopId;
              this.personAuditState = res.result.personAuditState;
              this.riskManagementRefuseReason = res.result.refuseReason;
              // this.queryAutoCheckStatus("receiptSn");
              // this.queryAutoCheckStatus("receiptDateStr");
              if (res.result && res.result.errorBillAudit) {
                this.errorBillAudit = res.result.errorBillAudit;
              }
            });
      } else {
        params.storeCode = v.storeCode;
        params.queryType = v.queryType;
        params.orderType = v.orderType;
        return this.$store
            .dispatch("detailsSalesVolumeList", params)
            .then(res => {
              this.receiptId = res.result.receiptId;
              this.declareRow = res.result.records;
              console.log("detail else res:", res);
              if (res.result.receiptDateStr !== "" && res.result.receiptDateStr) {
                this.receiptDateStrLength = res.result.receiptDateStr.length;
              }
              if (res.result.ocrShopName) {
                this.copyOcrShopName = JSON.parse(
                    JSON.stringify(res.result.ocrShopName || "")
                );
              }
              if (res.result && res.result.errorBillAudit) {
                this.errorBillAudit = res.result.errorBillAudit;
              }
              this.personAuditState = res.result.personAuditState;
              this.riskManagementRefuseReason = res.result.refuseReason;
              if (res.code === "0" && res.result === "-1") {
                this.$message({
                  message: "审核完毕,返回上一页!",
                  type: "success"
                });
                setTimeout(() => {
                  this.$router.back(-1);
                }, 2000);
              } else {
                // this.queryTempConfig(res.result.shopId);
                // this.queryNewNumAutoEnableSwitch(res.result.storeCode, res.result.shopId);
                this.numAutoEnableSwitchStoreCode = res.result.storeCode;
                this.numAutoEnableSwitchShopId = res.result.shopId;
                // this.queryAutoCheckStatus("receiptSn");
                // this.queryAutoCheckStatus("receiptDateStr");
              }
            });
      }
    },
  }
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
.mobile-tab-wrapper {
  background: #fff;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
.scrollocr::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
.scrollocr::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.scrollocr::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>
<style lang="scss" scoped>
.wb80 {
  width: 80%;
}
.wb20 {
  width: 20%;
}
.xiaoliang {
  background: linear-gradient(
    -90deg,
    rgba(173, 193, 251, 1),
    rgba(77, 119, 255, 1)
  );
}
.income {
  color: #e50065;
}
.title {
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
  height: 500px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.grid-contents {
  box-shadow: 0px 0px 18px 0px rgba(230, 230, 230, 1);
  border-radius: 6px;
  .hr {
    height: 1px;
    background: rgba(255, 255, 255, 1);
    opacity: 0.7;
  }
  .companyTitle {
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    padding: 10px 30px;
    white-space: nowrap;
  }
  .shengheType {
    padding: 10px 30px;
    .tit {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .titval {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 10px;
    }
  }
}
.card {
  color: #fff;
  font-size: 18px;
  border-radius: 6px;
  .companyTitle {
    margin-right: 15px;
    word-break: break-all;
  }
  .shengheType {
    padding: 10px 20px;
    .tit {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .titval {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 10px;
    }
  }
}

@media screen and (max-width: 414px) {
  .sales-volume-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            180deg,
            rgba(112, 154, 247, 1),
            rgba(84, 135, 247, 1),
            rgba(43, 106, 247, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }

      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
@media screen and (min-width: 415px) {
  .sales-volume-container {
    .pc {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
}

.input-range {
  margin-right: 10px;
  /deep/ .el-input-number {
    width: 100px;
    .el-input {
      width: 100%;
    }
  }
  .m-x5 {
    margin: 0 5px;
  };
}
.hideSelect /deep/ .el-table-column--selection{
  // display: none;
  width: 0;
  overflow: hidden;
}
</style>
